import '@fancyapps/ui/dist/fancybox/fancybox.css';

import { Fancybox } from '@fancyapps/ui';
import 'slick-carousel';
Fancybox.bind('[data-fancybox]');

import lottie from 'lottie-web/build/player/lottie_light';

import $ from 'jquery';
window.jQuery = $;

import Headroom from 'headroom.js';
var myElement = document.querySelector('header');

var options = {
  classes: {
    // when element is initialised
    initial: 'header',
    // when scrolling up
    pinned: 'pinned',
    // when scrolling down
    unpinned: 'unpinned',
    // when above offset
    top: 'top',
    // when below offset
    notTop: 'not-top',
    // when at bottom of scroll area
    bottom: 'bottom',
    // when not at bottom of scroll area
    notBottom: 'not-bottom',
    // when frozen method has been called
    frozen: 'frozen',
    // multiple classes are also supported with a space-separated list
    pinned: 'pinned',
  },
};

var headroom = new Headroom(myElement, options);

import { clearAllBodyScrollLocks, disableBodyScroll } from 'body-scroll-lock';

jQuery(document).ready(function ($) {
  // headroom.init();

  var targetElement = document.querySelector('.wrapper');

  $('.toggle').on('click', function (e) {
    e.preventDefault();
    if ($('.open')[0]) {
      clearAllBodyScrollLocks();
    } else {
      disableBodyScroll(targetElement);
    }

    $('.header').toggleClass('open');
  });

  var count = 1;
  setInterval(function () {
    count++;

    if ($('.animation__nav__item--active')[0]) {
      $('.animation__nav__item').removeClass('animation__nav__item--active');
      $("[data-index='" + count + "']").addClass('animation__nav__item--active');
    }

    if (count == 4) {
      count = 0;
    }
  }, 5000);

  if ($('.animation')[0]) {
    lottie.loadAnimation({
      container: document.getElementById('animation__src'),
      path: '/wp-content/themes/sneeuwzekerdeals/assets/animation/szd_animatie.json',
      renderer: 'svg',
      loop: true,
      autoplay: true,
    });
  }

  $('.slider--reviews').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    rows: 0,
    arrows: true,
    infinite: false,
    prevArrow: $('.slider.reviews .prev'),
    nextArrow: $('.slider.reviews .next'),
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1.2,
        },
      },
    ],
  });

  $('.block--why ul li').on('mouseover', function () {
    $('.block--why ul li').removeClass('active');
    $(this).addClass('active');
  });

  // Mobile menu
  $('.header__toggle').on('click', function (e) {
    e.preventDefault();
    $('.mobile').toggleClass('mobile--open');
    $(this).toggleClass('header__toggle__icon--open');
  });

  $('.mobile .menu-item-has-children > a').on('click', function (e) {
    e.preventDefault();
    $(this).parent().find('.sub-menu').toggleClass('mobile__dropdown-open');
  });

  // Read more
  $('.block--read-more .link').on('click', function (e) {
    e.preventDefault();
    $('.block--read-more .link').hide();
    $('.block--read-more .block__content').removeClass('hide');
  });

  // Dropdown menu
  var hideProductsTimeout = null;

  $('body').on('mouseenter', '.menu-item-has-children, .dropdown', function (e) {
    clearTimeout(hideProductsTimeout);

    var dropdown;

    if ($(this).attr('id')) {
      dropdown = $(this).attr('id').substring(10);

      $('.dropdown').removeClass('dropdown--open');
      $('[data-dropdown=' + dropdown + ']').addClass('dropdown--open');
    }
  });

  $('body').on('mouseleave', '.menu-item-has-children, .dropdown', function (e) {
    hideProductsTimeout = setTimeout(function () {
      $('.dropdown').removeClass('dropdown--open');
    }, 250);
  });

  /*-----------------------------------------------------------------------------------*/
  /*  Dynamic search
    /*-----------------------------------------------------------------------------------*/

  $('#search').on('change', 'input, select', function (e) {
    e.preventDefault();

    $('.loader').show();

    var values = {};
    var oldurl = window.location.href;
    var url = oldurl.split('?')[0];
    var url = $('form#search').attr('action');

    $.each($('form#search').serializeArray(), function (i, field) {
      url = addParameter(url, field.name, field.value);
    });

    // $('#loader').show();

    $.get(url, function (data) {
      // Insert data in villa list
      if ($('#searchResults').length) {
        results = $(data).find('#searchResults > *');
        $('#searchResults').html(results);

        offsetTop = $('#searchResults').offset().top;
      }

      // Scroll to results on mobile
      var browserWidth = $(document).width();
      if (browserWidth < 768) {
        $('html, body').animate({ scrollTop: offsetTop - 80 }, '1000');
      }
      // Equal heights
      $(window).trigger('resize');

      // Hide loader
      $('.loader').hide();
    });

    window.history.pushState(null, null, url);
  });

  // $('#newsletter').click(function(e) {
  //     e.preventDefault();
  //     console.log($("#newsletter input").val());
  //     $.ajax({
  //         type: 'POST',
  //         url: 'https://api.inboxify.nl/contacts/4D6D6C48467765694D4B513D/495566674A6F636A6772303D',
  //         data: { email: $("#newsletter input").val() },
  //         success: function(data) {
  //             // Print the response data
  //             console.log('Response: ' + data);
  //         }
  //     });
  // });
});
